import React, { useRef } from 'react';
import { useSlidingIndicator } from '../../../../hooks/useSlidingIndicator';

const MOTION = 'var(--dur-base) var(--ease-out)';

export function SegmentedControl({
  options,
  value,
  onChange,
  ariaLabel,
  compact = false,
}) {
  const ref = useRef(null);
  // Anel da opção ativa: desliza (transform/width/height) até a opção escolhida.
  const ring = useSlidingIndicator(
    ref,
    '[aria-pressed="true"]',
    `${String(value)}|${options.length}|${compact}`,
  );

  return (
    <div
      ref={ref}
      role="group"
      aria-label={ariaLabel}
      style={{
        position: 'relative',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'var(--space-8)',
      }}
    >
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={String(opt.value)}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(opt.value)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              height: compact ? 'var(--space-32)' : 'var(--space-40)',
              padding: compact ? '0 var(--space-12)' : '0 var(--space-16)',
              borderRadius: 'var(--radius-full)',
              border: 'var(--stroke-small) solid var(--border-neutral-strong)',
              background: active
                ? 'var(--bg-brand-subtler)'
                : 'var(--bg-neutral-layer01)',
              color: active
                ? 'var(--fg-brand-stronger)'
                : 'var(--fg-neutral-subtle)',
              fontFamily: 'inherit',
              fontSize: 'var(--fs-14)',
              fontWeight: 'var(--fw-medium)',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              transition: `background-color ${MOTION}, color ${MOTION}`,
            }}
          >
            {opt.label}
          </button>
        );
      })}
      {ring && (
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: ring.w,
            height: ring.h,
            transform: `translate(${ring.x}px, ${ring.y}px)`,
            boxSizing: 'border-box',
            borderRadius: 'var(--radius-full)',
            border: 'var(--stroke-small) solid var(--border-brand-default)',
            pointerEvents: 'none',
            transition: `transform ${MOTION}, width ${MOTION}, height ${MOTION}`,
          }}
        />
      )}
    </div>
  );
}
